import EnrollmentFieldsVM from './enrollment-fields-vm';
export default {
  init : function() {
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;

    var fields_data = JSON.parse($('#fields_json').val());
    ko.applyBindingsWithValidation(new EnrollmentFieldsVM(fields_data), document.getElementById('js-course-enrollment-fields-form'), validationOptions);
  }
};
